const dataInfoProduct = [
	{
		id_produto: 2,
		title: "Para começar o seu negócio e decolar nesse mundo digital.",
		features: [
			"+ Controle de Estoque",
			"+ Controle de Clientes e Funcionários",
			"+ Criação de Promoções",
			"+ Ferramentas de Marketing",
			"+ Gerenciamento de Coleções",
			"+ Configuração de Marca e Layout",
			"+ Intragração com Outras Plataformas (como Facebook/Instagram)",
			"e muito mais",
		],
		warning: "Atenção: nesse plano não é possivel vender online, apenas exibir produtos",
	},
	{
		id_produto: 3,
		title: "Para começar o seu negócio e decolar nesse mundo digital.",
		features: [
			"+ Controle de Estoque",
			"+ Controle de Clientes e Funcionários",
			"+ Criação de Promoções",
			"+ Ferramentas de Marketing",
			"+ Gerenciamento de Coleções",
			"+ Configuração de Marca e Layout",
			"+ Intragração com Outras Plataformas (como Facebook/Instagram)",
			"e muito mais",
		],
		warning: "Atenção: nesse plano não é possivel vender online, apenas exibir produtos",
	},
	{
		id_produto: 4,
		title: "A solução ideal para gerenciar seu ponto de venda com eficiência e profissionalismo.",
		features: [
			"+ Controle completo de Estoque em tempo real",
			"+ Cadastro e gerenciamento de Clientes e Funcionários",
			"+ Criação de Promoções e descontos personalizados",
			"+ Ferramentas de Marketing para fidelização de clientes",
			"+ Organização de Produtos por Categorias e Coleções",
			"+ Personalização de Marca e Layout do sistema",
			"+ Integração com sistemas e redes sociais (Facebook, Instagram, etc.)",
			"+ Emissão de relatórios e análises de vendas",
		],
		warning: "Atenção: este plano é voltado para vendas presenciais — não permite vendas online.",
	},

	{
		id_produto: 5,
		title: "Automatize seu atendimento e conquiste mais clientes com campanhas de WhatsApp em massa.",
		features: [
			"+ Envio de mensagens em massa via WhatsApp com agendamento",
			"+ Cadastro e segmentação de leads",
			"+ Criação de campanhas personalizadas com mensagens dinâmicas",
			"+ Histórico de interações com cada lead",
			"+ Ferramentas de funil de vendas e acompanhamento",
			"+ Importação de contatos a partir de planilhas ou CRM",
			"+ Geração de relatórios de desempenho das campanhas",
			"+ Integração com sistemas externos via API",
		],
		warning: "Atenção: o uso do WhatsApp deve seguir as políticas da plataforma para evitar bloqueios.",
	},
];

export default dataInfoProduct;
